export function mapStaffWebsiteTestimonial(row) {
  if (!row) return null;
  return {
    id: row.id,
    type: row.type,
    name: row.name,
    role: row.role || "",
    quote: row.quote || "",
    investmentType: row.investment_type || "",
    imageUrl: row.image_url || "",
    videoUrl: row.video_url || "",
    youtubeId: row.youtube_id || "",
    isPublished: Boolean(row.is_published),
    isFeatured: Boolean(row.is_featured),
    sortOrder: Number(row.sort_order) || 0,
    createdAt: row.created_at || null,
    updatedAt: row.updated_at || null,
  };
}

export function toStaffWebsiteTestimonialPayload(values) {
  const payload = {
    type: values.type,
    name: values.name?.trim(),
    role: values.role?.trim() || null,
    quote: values.quote?.trim() || null,
    investment_type: values.investmentType?.trim() || null,
    image_url: values.imageUrl?.trim() || null,
    video_url: values.videoUrl?.trim() || null,
    youtube_id: values.youtubeId?.trim() || values.youtubeUrl?.trim() || null,
    is_published: Boolean(values.isPublished),
    is_featured: Boolean(values.isFeatured),
    sort_order: Number(values.sortOrder) || 0,
  };

  if (payload.type === "written") {
    payload.video_url = null;
    payload.youtube_id = null;
  }

  return payload;
}
